import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'react-bootstrap';
import Flex from '@/components/common/Flex';
import { Link } from 'react-router-dom';
import { useGetLastOrderQuery } from '@/app/Purchase/api/ordersApi';
import TextLoading from '../../common/components/skeleton/TextLoading';
import numberHumanizer from '@/helpers/numberHumanizer';
import classNames from 'classnames';

function Overview() {
  const { data: lastOrder, isLoading: isLoadingOrder } = useGetLastOrderQuery();
  return (
    <div className="d-flex justify-content-center flex-column align-items-center gap-3">
      <div className="px-md-6 pt-4 pb-2">
        <Flex className="position-relative" alignItems="center">
          <div
            style={{
              fontSize: '1.70rem',
              width: '3.125rem',
              height: '3.425rem'
            }}
            className="icon-item  border rounded-3 shadow-none me-2"
          >
            {/* <FontAwesomeIcon icon="crown" className="text-primary" /> */}
            {isLoadingOrder ? (
              <TextLoading width={34} height={34} isWidthPx />
            ) : (
              <img
                width="34"
                className="rounded-lg"
                src={`https://static.mizfa.tools/img/price-logo/lion-${lastOrder?.data?.tariff_group === 0 ? 1 : lastOrder?.data?.tariff_group}.svg`}
              />
            )}
          </div>
          <div className="flex-1">
            <h6 className="mb-2 stretched-link fs-0 fw-black text-800">
              {isLoadingOrder ? (
                <TextLoading isWidthPx width={100} height={15} />
              ) : lastOrder?.data?.tariff ? (
                lastOrder?.data?.tariff
              ) : (
                'بدون طرح'
              )}
              &nbsp;
              <span className="fs--2 fw-bold text-600">(طرح فعلی)</span>
            </h6>
            <p className="mb-0 fs-0 fw-medium text-800">
              {isLoadingOrder ? (
                <TextLoading isWidthPx width={165} />
              ) : (
                <>
                  {lastOrder?.data?.tariff && (
                    <>
                      {numberHumanizer(lastOrder?.data?.price)} تومان -{' '}
                      {lastOrder?.data?.period}
                    </>
                  )}
                </>
              )}
            </p>
          </div>
        </Flex>
      </div>
      <Flex className="gap-2 mb-5">
        <Link
          to="/prorogate-or-upgrade/"
          className={classNames('text-decoration-none', {
            'disabled-link': isLoadingOrder
          })}
        >
          <Button
            className="d-flex align-items-center gap-2"
            variant="falcon-primary"
          >
            <FontAwesomeIcon icon="level-up" />
            خرید طرح
          </Button>
        </Link>
      </Flex>
    </div>
  );
};

export default Overview;
